/*
 * @Author: Junchi Zhao
 * @LastEditors: Junchi Zhao
 * @Description:
 */
import { startMode } from '@/config';
import dayjs from 'dayjs';
import BigDecimal from 'js-big-decimal';
//防抖
function debounce(func, delay, immediate) {
  let timer = null;
  return function () {
    const context = this;
    const args = arguments;
    if (timer) {
      clearTimeout(timer);
    }
    if (immediate) {
      const doNow = !timer;
      timer = setTimeout(function () {
        timer = null;
      }, delay);
      if (doNow) {
        func.apply(context, args);
      }
    } else {
      timer = setTimeout(function () {
        func.apply(context, args);
      }, delay);
    }
  };
}
//节流
function throttle(func, delay) {
  let timer = null;
  return function () {
    const context = this;
    const args = arguments;
    if (!timer) {
      timer = setTimeout(function () {
        func.apply(context, args);
        timer = null;
      }, delay);
    }
  };
}

//将对象中数字类型转string
function resetNumberToString(data) {
  if (!data) {
    return {};
  }
  if (Object.prototype.toString.call(data) === '[object Object]') {
    for (const key in data) {
      if (Object.prototype.toString.call(data[key]) === '[object Number]') {
        data[key] = data[key].toString();
      } else {
        this.resetNumberToString(data[key]);
      }
    }
  } else if (Object.prototype.toString.call(data) === '[object Array]') {
    for (const iterator of data) {
      if (Object.prototype.toString.call(iterator) === '[object Object]') {
        this.resetNumberToString(iterator);
      }
    }
  }
  return data;
}

//保留小数点位的0
function setNumberZero(value, size) {
  if (typeof value === 'number') {
    return value.toFixed(size);
  } else {
    return null;
  }
}

function formatDate(date, format = 'YYYY-MM-DD') {
  if (!date) {
    return '';
  } else {
    return dayjs(date).format(format);
  }
}

function add(nums, round) {
  if (!nums) return;
  let res = new BigDecimal(0);
  for (const num of nums) {
    res = res.add(new BigDecimal(num));
  }
  // eslint-disable-next-line no-undefined
  if (round !== undefined) {
    return res.round(round).getValue();
  } else {
    return res.getValue();
  }
}
function round(num, round) {
  return new BigDecimal(num).round(round).getValue();
}
function subtract(nums, round) {
  if (!nums) return;
  let res = new BigDecimal(nums[0]);
  for (let i = 1; i < nums.length; i++) {
    res = res.subtract(new BigDecimal(nums[i]));
  }
  // eslint-disable-next-line no-undefined
  if (round !== undefined) {
    return res.round(round).getValue();
  } else {
    return res.getValue();
  }
}
function multiply(nums, round) {
  if (!nums) return;
  let res = new BigDecimal(1);
  for (const num of nums) {
    res = res.multiply(new BigDecimal(num));
  }
  // eslint-disable-next-line no-undefined
  if (round !== undefined) {
    return res.round(round).getValue();
  } else {
    return res.getValue();
  }
}
function divide(nums, round) {
  if (!nums) return;
  let res = new BigDecimal(nums[0]);
  for (let i = 1; i < nums.length; i++) {
    res = res.divide(new BigDecimal(nums[i]));
  }
  // eslint-disable-next-line no-undefined
  if (round !== undefined) {
    return res.round(round).getValue();
  } else {
    return res.getValue();
  }
}

function formatMoney(val) {
  if (val === 0) {
    return '0.00';
  }
  if (val) {
    const _val = (val * 1).toFixed(2);
    return _val.toString().replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
  } else {
    return '';
  }
}

function isObject(value) {
  return Object.prototype.toString.call(value) === '[object Object]';
}

function isArray(value) {
  return Object.prototype.toString.call(value) === '[object Array]';
}

function isString(value) {
  return Object.prototype.toString.call(value) === '[object String]';
}

function isBoolean(value) {
  return Object.prototype.toString.call(value) === '[object Boolean]';
}

function isNumber(value) {
  return Object.prototype.toString.call(value) === '[object Number]';
}

function isNotU(value) {
  // eslint-disable-next-line no-undefined
  return value !== undefined;
}
function isNotN(value) {
  return value !== null;
}

//打开pageoffice
function openWindowModeless(url, windowStyle, callback) {
  window.callback = callback;
  // eslint-disable-next-line no-undef
  POBrowser.openWindowModeless(url, windowStyle, 'POBrowser');
}
/**
 * @description: 计算静态文件路径（判断vite还是webpack）
 * @param {*} url
 * @return {*}
 * @author: Junchi Zhao
 */
function calcStaticFileUrl(url) {
  if (startMode === 'webpack') {
    return url;
  } else {
    return url.replace('./static', '');
  }
}
function getClientUrl() {
  let url = '';
  //多pathname且包含index.html
  if (window.location.pathname && window.location.pathname.indexOf('.') > -1) {
    url =
      window.location.origin +
      window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/'));
  } else if (window.location.pathname) {
    url = window.location.origin + window.location.pathname;
  } else {
    url = window.location.origin;
  }
  return url;
}
export default {
  install(Vue, options) {
    Vue.prototype.throttle = throttle;
    Vue.prototype.debounce = debounce;
    Vue.prototype.resetNumberToString = resetNumberToString;
    Vue.prototype.setNumberZero = setNumberZero;
    Vue.prototype.formatDate = formatDate;
    Vue.prototype.formatMoney = formatMoney;
    Vue.prototype.isObject = isObject;
    Vue.prototype.isArray = isArray;
    Vue.prototype.isString = isString;
    Vue.prototype.isBoolean = isBoolean;
    Vue.prototype.isNumber = isNumber;
    Vue.prototype.isNotU = isNotU;
    Vue.prototype.isNotN = isNotN;
    Vue.prototype.openWindowModeless = openWindowModeless;
    Vue.prototype.calcStaticFileUrl = calcStaticFileUrl;
    Vue.prototype.getClientUrl = getClientUrl;
    Vue.prototype.add = add;
    Vue.prototype.round = round;
    Vue.prototype.subtract = subtract;
    Vue.prototype.multiply = multiply;
    Vue.prototype.divide = divide;
  },
  isArray
};
